// Central Chart.js registration. Import this once wherever a Chart.js chart is
// rendered (Dashboard doughnuts/bars, StatCard sparklines, RadialGauge). Keeping
// registration in one place avoids "not a registered element" errors when a
// component that draws a line/arc is mounted without the Dashboard.
import {
  Chart as ChartJS,
  ArcElement,
  Tooltip,
  Legend,
  CategoryScale,
  LinearScale,
  BarElement,
  LineElement,
  PointElement,
  Filler,
} from 'chart.js'

ChartJS.register(
  ArcElement,
  Tooltip,
  Legend,
  CategoryScale,
  LinearScale,
  BarElement,
  LineElement,
  PointElement,
  Filler,
)

export { ChartJS }
